import { Flex } from '@radix-ui/themes'
import { formatValue } from './claim-form-utils'
import { FieldRow } from './claim-form-fields'
import { CONTACT_ROWS, CONTACT_SECTION_PATH } from './claim-form-constants'
import { getFieldLabel, getSchemaNode } from './claim-form-schema-utils'

export function ContactFields({
  data,
  formData,
  schema,
}: {
  data: Record<string, unknown>
  formData?: Record<string, unknown>
  schema?: Record<string, unknown>
}) {
  const claimant = (formData?.claimant ?? {}) as { usCitizen?: boolean }
  const isUS = claimant.usCitizen !== false
  const regionLabel = isUS ? 'State' : 'Province/Region'

  const contactProperties = getSchemaNode(schema, CONTACT_SECTION_PATH)?.properties as
    | Record<string, unknown>
    | undefined

  // A field the customer's schema does not define renders nothing, as it does in the editable view.
  // Before the schema loads nothing can be excluded, so every row renders.
  const hasField = (field: string) => !contactProperties || field in contactProperties

  const labelFor = (field: string) => {
    if (field === 'region') {
      return regionLabel
    }
    return getFieldLabel(field, schema, CONTACT_SECTION_PATH)
  }

  return (
    <Flex direction="column" gap="3">
      {CONTACT_ROWS.filter(([left, right]) => hasField(left) || (right && hasField(right))).map(
        ([left, right]) => (
          <div key={left} className="claim-form-two-col">
            {hasField(left) ? (
              <FieldRow label={labelFor(left)} value={formatValue(data[left])} />
            ) : (
              <div />
            )}
            {right && hasField(right) ? (
              <FieldRow label={labelFor(right)} value={formatValue(data[right])} />
            ) : (
              <div />
            )}
          </div>
        ),
      )}
    </Flex>
  )
}
